/**
 * Факты о продукте без единой внешней зависимости.
 *
 * Модуль отдельный намеренно: его импортирует `vite.config.ts`, который грузится
 * до применения алиасов и не умеет тянуть React. Всё остальное — разметка, страницы,
 * генератор llms.txt — цитирует эти значения, чтобы цифры не расходились.
 */

export const SITE_URL = "https://polotno.tech";
export const SITE_NAME = "Polotno";

const BASIC_MONTHLY_PRICE = 598;
const BASIC_YEARLY_PRICE = 5740;

/** Реальные параметры тарифов — синхронизированы с backend/src/constants/plan-configs.ts, включая yearlyPrice */
export const PRICING_FACTS = {
  trial: { minutes: 150, price: 99, days: 7 },
  basic: { minutes: 450, price: BASIC_MONTHLY_PRICE, extraMinutePrice: 1.5, yearlyPrice: BASIC_YEARLY_PRICE },
  pro: { minutes: 2000, price: 1500, extraMinutePrice: 1, yearlyPrice: 14400 },
  packages: [100, 500, 1000],
  payPerMinutePrice: 2.5,
  yearlyDiscountPercent: Math.round((1 - BASIC_YEARLY_PRICE / (BASIC_MONTHLY_PRICE * 12)) * 100),
  maxFileSizeGb: 2,
  maxDurationHours: 4,
  /** Точность на записях хорошего качества. «99% всегда» не писать */
  accuracy: "95–99%",
  /** Время обработки в процентах от длительности записи */
  processingShare: "10–15%",
  languagesCount: 99,
  /**
   * Доступны только в режиме «Качество» (AssemblyAI Universal-2).
   * В быстром режиме на Deepgram nova-3 этих языков нет.
   */
  qualityOnlyLanguages: ["казахский", "узбекский", "армянский", "грузинский"],
  /**
   * Квота расходуется вопросами в чате по расшифровке, а не сводками:
   * автосводка после расшифровки входит в тариф без ограничений.
   */
  chatQuestions: { trial: 5, basic: 25, pro: 50 }
} as const;

/** Единый источник контактных данных: страница /contacts, футер и разметка берут их отсюда */
export const CONTACTS = {
  legalName: "Постика Максим Феликсович",
  taxId: "311404938543",
  email: "support@polotno.tech",
  supportBotUrl: "https://t.me/Polotno_support_bot",
  transcribeBotUrl: "https://t.me/PolontoTranscribe_bot",
  transcribeBotName: "@PolontoTranscribe_bot",
  yandexBusinessUrl: "https://yandex.ru/profile/118253083124",
  productHuntUrl: "https://www.producthunt.com/products/polotno",
  indieHackersUrl: "https://www.indiehackers.com/product/polotno"
} as const;
